import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'azure-openai',
  name: 'Azure OpenAI',
  category: 'ai',
  description: 'Azure-hosted OpenAI GPT models for chat conversations and text generation',
  icon: 'siMicrosoftazure',
  iconType: 'simple-icon',
  color: 'blue',
  version: '1.0.0',

  // Mark as sub-node - only used with AI Agent
  isSubNode: true,
  subNodeConfig: {
    category: 'chatModel',
    requiredFor: ['aiAgent'],
    multipleAllowed: false // Only one chat model per AI Agent
  },

  group: ['ai'],

  defaults: {
    name: 'Azure OpenAI',
    color: '#0078d4'
  },

  subtitle: '={{ $parameter.deploymentName }}',

  credentials: [
    {
      name: 'azure-openai',
      required: true,
      displayName: 'Azure OpenAI API'
    }
  ],

  // Sub-nodes don't have traditional inputs/outputs
  // They are connected via special anchors
  inputs: [],
  outputs: [],

  // Anchors define the visual connection points
  anchors: {
    input: [
      {
        type: 'subNode',
        subNodeCategory: 'chatModel',
        label: 'Chat Model',
        multiple: false
      }
    ]
  },

  tags: ['ai', 'azure', 'openai', 'gpt', 'llm', 'chat', 'completion', 'text-generation', 'microsoft']
};

export default definition;
